import store from '@/store'

export const checkUserMaster = () => {
  const checkUser = store.state.auth.userData.permission.name
  return checkUser
}

export default checkUserMaster
